export const GET_ROSTER_FOR_INCIDENT_REQUEST = 'GET_ROSTER_FOR_INCIDENT_REQUEST';
export const GET_ROSTER_FOR_INCIDENT_SUCCESS = 'GET_ROSTER_FOR_INCIDENT_SUCCESS';
export const GET_ROSTER_FOR_INCIDENT_ERROR = 'GET_ROSTER_FOR_INCIDENT_ERROR';
export const ADD_USER_TO_INCIDENT_BY_ADMIN_ERROR = 'ADD_USER_TO_INCIDENT_BY_ADMIN_ERROR';
export const REMOVE_USER_FROM_INCIDENT_BY_ADMIN_REQUEST = 'REMOVE_USER_FROM_INCIDENT_BY_ADMIN_REQUEST';
export const REMOVE_USER_FROM_INCIDENT_BY_ADMIN_SUCCESS = 'REMOVE_USER_FROM_INCIDENT_BY_ADMIN_SUCCESS';
export const REMOVE_USER_FROM_INCIDENT_BY_ADMIN_ERROR = 'REMOVE_USER_FROM_INCIDENT_BY_ADMIN_ERROR';
export const REMOVE_SELF_FROM_INCIDENT_REQUEST = 'REMOVE_SELF_FROM_INCIDENT_REQUEST';
export const REMOVE_SELF_FROM_INCIDENT_SUCCESS = 'REMOVE_SELF_FROM_INCIDENT_SUCCESS';
export const REMOVE_SELF_FROM_INCIDENT_ERROR = 'REMOVE_SELF_FROM_INCIDENT_ERROR';
export const GET_INCIDENT_LOGS = 'GET_INCIDENT_LOGS'
export const UPDATE_INCIDENT_LOGS_WITH_WORKLOG = 'UPDATE_INCIDENT_LOGS_WITH_WORKLOG';
export const ADD_SCHEDULE_TO_INCIDENT_REQUEST = 'ADD_SCHEDULE_TO_INCIDENT_REQUEST';
export const ADD_SCHEDULE_TO_INCIDENT_SUCCESS = 'ADD_SCHEDULE_TO_INCIDENT_SUCCESS';


